/**
 * Never let the browser fall back silently (RESTYLE_BRIEF.md "Font"): Inter is self-hosted (@fontsource-variable/inter,
 * imported in main.tsx), so once the page's fonts have settled it must be available. If it is not, say so in the console,
 * where a build check or a person looking at a blurry screen will see it. Nothing is sent anywhere.
 */
export const APP_FONT_FAMILY = 'Inter Variable';
export const APP_FONT_PROBE = `400 14px "${APP_FONT_FAMILY}"`;

/** The parts of `document.fonts` (FontFaceSet) this needs, so tests can pass a stand-in. */
export interface FontSetLike {
  ready: Promise<unknown>;
  check(font: string, text?: string): boolean;
  load(font: string, text?: string): Promise<unknown[]>;
}

/**
 * Resolves true when Inter is loaded. Otherwise warns once and resolves false. It asks for the font to load first, so the
 * check does not depend on whether any text has been drawn in Inter yet.
 */
export async function checkAppFont(fonts: FontSetLike | undefined, warn: (message: string) => void = (m) => console.warn(m)): Promise<boolean> {
  if (!fonts) return true; // No Font Loading API (very old browser): nothing to check against.
  try {
    await fonts.load(APP_FONT_PROBE).catch(() => []);
    await fonts.ready;
    if (fonts.check(APP_FONT_PROBE)) return true;
  } catch {
    /* fall through to the warning */
  }
  warn(`[chapsi] The app font (${APP_FONT_FAMILY}) did not load, so text is drawn in a fallback font. Check that the self-hosted Inter files are served.`);
  return false;
}
